import React, { useContext, useEffect, useState } from 'react'
import Wizard from '../Wizard'
// import { makeStyles } from '@material-ui/core'
import { CampaignContext } from '../../../contexts/CampaignContext'
import BrandsContext from '../../../contexts/BrandsContext'
import { getAddCampaignParams } from '../../../utils/payload-generator'
import { useHistory, useLocation } from 'react-router-dom'
import CampaignSubmittedDialog from '../CampaignSubmittedDialog'
import { GoToListPage } from '../../shared/types/RoutingTypes'
import { LoaderDialog } from 'functional-foundations'

const Create = ({ goToListPage }: GoToListPage) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const {
        addCampaign,
        campaignNetworkError,
        setCampaignNetworkError
    } = useContext(CampaignContext)

    const {
        fetchBrands,
        initialFetchParams: initialBrandFetchParams
    } = useContext(BrandsContext)

    useEffect(() => {
        if (campaignNetworkError) setIsDialogOpen(false)
    }, [campaignNetworkError])

    const { pathname } = useLocation()
    const history = useHistory()

    const appPath = '/campaigns'
    const basePath = `${pathname.split(appPath)[0]}`

    const onSubmitHandler = async (data) => {
        setLoading(true)
        try {
            setCampaignNetworkError(null)
            const addParams = await getAddCampaignParams(
                data,
                {
                    onSuccess: () => fetchBrands(initialBrandFetchParams)
                }
            )
            await addCampaign(addParams)
            setIsDialogOpen(true)
        } catch (err) {
            setCampaignNetworkError('Something went wrong')
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const goToNumbeAssignementPage = () => {
        setIsDialogOpen(false)
        history.push(`${basePath}/number-assignement/create`)
    }

    return <div>
        <Wizard
            onSubmit={onSubmitHandler}
            goToListPage={goToListPage}
        />
        <CampaignSubmittedDialog
            isOpen={isDialogOpen}
            onContinue={goToNumbeAssignementPage}
            onClose={goToListPage}
        />
        <LoaderDialog
            isOpen={loading}
            title={'Processing your payment...'}
            subtitle='Please wait!'
            data-testid='loader-dialog'
        />
    </div>
}

export default Create
